<ng-container *ngIf="outlet" [ngSwitch]="location">
  <ng-container *ngSwitchCase="dealerLocatorLocation.Body">
    <div class="cc-dealer">
      <ccwb-heading size="s">{{ 'dealerLocator.yourDealer' | translate }}</ccwb-heading>
      <div class="cc-dealer__card">
        <ccwb-grid full-width>
          <ccwb-grid-row class="cc-flex-justify-between">
            <ccwb-grid-col class="cc-dealer__address" mq1="12" mq3="6">
              <ccwb-text size="l" strong>{{ outlet.name }}</ccwb-text>
              <ccwb-text *ngIf="outlet.street" size="l">{{ outlet.street }}</ccwb-text>
              <ccwb-text *ngIf="outlet.location" size="l">{{ outlet.location }}</ccwb-text>
            </ccwb-grid-col>
            <ccwb-grid-col class="cc-dealer__contact" mq1="12" mq3="6">
              <ccwb-text class="cc-dealer__contact-item" *ngIf="outlet.phone" size="l">
                <span class="details-container">
                  <ccwb-icon class="cc-dealer__contact-icons" name="bds/call/24" />
                  <div>{{ 'dealerLocator.phone' | translate: outlet.phone }}</div>
                </span>
              </ccwb-text>
              <ccwb-text class="cc-dealer__contact-item" *ngIf="outlet.fax" size="l">
                <span class="details-container">
                  <ccwb-icon class="cc-dealer__contact-icons" name="bds/print/16" />
                  <div>{{ 'dealerLocator.fax' | translate: outlet.fax }}</div>
                </span>
              </ccwb-text>
              <ccwb-text class="cc-dealer__contact-item" *ngIf="outlet.email" size="l">
                <span class="details-container">
                  <ccwb-icon class="cc-dealer__contact-icons" name="bds/mail/16" />
                  <div class="cc-dealer__contact-item--text">
                    <span class="cc-dealer__mail">{{ 'dealerLocator.email' | translate: '' }}</span>
                    <ccwb-link href="mailto:{{ outlet.email }}" variant="inline">
                      <span>{{ outlet.email }}</span></ccwb-link
                    >
                  </div>
                </span>
              </ccwb-text>
              <ccwb-text class="cc-dealer__contact-item cc-dealer__contact-item__last" *ngIf="outlet.homepage" size="l">
                <span class="details-container">
                  <ccwb-icon class="cc-dealer__contact-icons" name="bds/globe/24" />
                  <ccwb-link href="{{ outlet.homepage }}" variant="inline" target="_blank" rel="noopener">
                    <span>{{ outlet.homepage }}</span></ccwb-link
                  >
                </span>
              </ccwb-text>
            </ccwb-grid-col>
          </ccwb-grid-row>
        </ccwb-grid>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="dealerLocatorLocation.Header">
    <div class="cc-dealer--header cc-display--flex" *ngIf="subprocess === subprocessCheck">
      <div>
        <ccwb-text tag="span" size="l" strong>{{ outlet.name }}</ccwb-text>
        <ccwb-text *ngIf="outlet.phone" size="l">{{ 'dealerLocator.phone' | translate: outlet.phone }}</ccwb-text>
        <ccwb-link
          *ngIf="outlet?.homepage as homepage"
          href="{{ homepage }}"
          variant="standalone"
          target="_blank"
          rel="noopener"
          >{{ homepage }}</ccwb-link
        >
      </div>
      <cc-image
        class="cc-dealer__logo cc-display--flex cc-flex-align-center"
        *ngIf="outlet.retailerLogoUrl"
        [src]="outlet.retailerLogoUrl"
      />
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="dealerLocatorLocation.Footer">
    <div class="cc-footer-links">
      <div class="cc-grid-container">
        <ul class="cc-footer-links__list" *ngIf="outlet && outlet.footer">
          <li class="cc-footer-links__list-item" *ngFor="let item of outlet.footer | keyvalue" size="l">
            <a *ngIf="item.value.id !== copyrightInfo" [ccModalLink]="[modalComponent, item]"
              ><ccwb-text size="l">{{ item.key }}</ccwb-text></a
            >
            <ccwb-text
              *ngIf="item.value.id === copyrightInfo"
              [innerHTML]="item.value.text | bypassHtmlSecurity"
              size="l"
              tag="p"
            />
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</ng-container>
